module.exports = __webpack_public_path__ + "img/endPoint.f9a38399.png";